import { ArtistCard } from "@components/artist_card/artist_card";
import { useArtists } from "@contexts/artists_context";
import React, { FC, useMemo } from "react";

interface ArtistsGridProps {
  includeNames: boolean;
}

const ArtistsGrid: FC<ArtistsGridProps> = ({ includeNames }) => {
  const { artists } = useArtists();

  const filteredArtists = useMemo(() => {
    if (!artists || artists.length === 0) {
      return [];
    }
    return artists.filter((a) => a.artPieceIds?.length > 0);
  }, [artists]);

  if (!artists || artists.length === 0) {
    return null;
  }

  return (
    <div className="artists-grid">
      {filteredArtists.map((artist) => (
        <ArtistCard
          key={artist.login}
          classes="artists-grid--item"
          artist={artist}
          includeName={includeNames}
        />
      ))}
    </div>
  );
};

export { ArtistsGrid, ArtistsGridProps };
